import { render } from "./TemplateFileAndInfo.vue?vue&type=template&id=1f347052&scoped=true&ts=true"
import script from "./TemplateFileAndInfo.vue?vue&type=script&lang=ts"
export * from "./TemplateFileAndInfo.vue?vue&type=script&lang=ts"

import "./TemplateFileAndInfo.vue?vue&type=style&index=0&id=1f347052&lang=scss&scoped=true"

import exportComponent from "/builds/digitalsign/frontendweb/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1f347052"]])

export default __exports__